import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {InfoWindow as InfoWindowGM} from '@react-google-maps/api';

import './InfoWindow.scss';
import styles from './InfoWindow.module.scss';
import Context from '../../context';

export const InfoWindow = ({position, content, visible}) => {
  const {checkInfoWindow} = useContext(Context);

  if (!visible) return null;

  return (
    <InfoWindowGM
      position={position}
      options={{
        pane: 'overlayLayer',
        pixelOffset: new window.google.maps.Size(0, -45),
        alignBottom: true,
        closeBoxURL: '',
      }}
      onDomReady={checkInfoWindow}
    >
      <div className={styles.tooltipContent}>{content}</div>
    </InfoWindowGM>
  );
};

InfoWindow.propTypes = {
  position: PropTypes.object.isRequired,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  visible: PropTypes.bool,
};

InfoWindow.defaultProps = {
  visible: true,
};
